import moment from 'moment';
import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import formsActionCreators from '../../store/forms/action-creators';
import classNames from 'classnames';
import ReactTooltip from 'react-tooltip'
import {Input} from "reactstrap";
import AddActionButton from "../common/AddActionButton";
import Modal from "../../../shared/ui/Modal";
import CustomForm from "../../../shared/components/form/CustomForm";
import {createFormConfig} from "../../../shared/components/form/CreateFormConfig";
import commonActions from "../../../shared/store/common/action-creators";

class FormIndex extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selectedFormStatus: 'current',
      isCreatingForm: false,
      isCreateFormLoading: false
    }
  }

  // ----------------------
  // Handlers
  // ----------------------

  onActivateForm(formGuid) {
    this.props.activateForm(formGuid);
  }

  onReviseForm(formGuid) {
    this.props.reviseForm(formGuid)
      .then((draftGuid) => {
        this.onViewForm(draftGuid);
      });
  }

  onViewForm(formGuid) {
    this.props.setSelectedForm(formGuid);
    if(this.props.userContext.hasScope(['admin'])) {
      this.props.history.push(`/admin/forms/${formGuid}`);
    } else {
      this.props.history.push(`/forms/${formGuid}`);
    }
  }

  canEditOrActivate(form) {
    return form.status === 'draft' && this.props.userContext.hasScope('depadmin')
  }

  openCreateFormModal() {
    this.setState({
      isCreatingForm: true,
    })
  }

  closeCreateForm() {
    this.setState({
      isCreatingForm: false,
    })
  }


  // ----------------------
  // Methods
  // ----------------------

  getCanRevise(form) {
    if (form.status !== 'current') {
      return false;
    }
    const {type} = form;
    return !this.props.forms.find((existingForm) => {
      return existingForm.type === type && existingForm.status === 'draft';
    }) && this.props.userContext.hasScope('depadmin');
  }

  setFormStatus(formStatus) {
    this.setState({
      selectedFormStatus: formStatus
    })
  }

  onSubmit(form) {
    this.setState({
      isCreateFormLoading: true
    });

    let settings = undefined;

    if (form.scale || form.riskAlert) {
      settings = {
        scale: form.scale ? parseInt(form.scale) : null,
        riskAlert: form.riskAlert ? parseInt(form.riskAlert) : null,
      }
    }

    (form.type_new ? this.props.createFormType(form.type_new)
      .then(() => form.type_new) : Promise.resolve(form.type))
      .then((type) => this.props.createForm({name: form.name, settings, type, layout: []}))
      .then((data) => {
        this.setState({
          isCreateFormLoading: false
        });
        this.closeCreateForm()
        this.onViewForm(data.guid)
      })
      .catch(() => {
        this.setState({
          isCreateFormLoading: false
        });
      });
  }


  get filteredForms() {
    return !!this.state.selectedFormStatus && this.props.forms
      ? this.props.forms.filter(f => f.status === this.state.selectedFormStatus)
      : this.props.forms;
  }

  render() {
    return !this.isLoading && (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">Forms</h4>
          {this.props.userContext.hasScope('admin') &&
          <AddActionButton label="Form" onAdd={() => this.openCreateFormModal()}/>
          }
        </div>
        <div className="app-content">
          <div className="form form-inline">
            <div className="form-group" style={{flex: 0.3}}>
              <Input
                name="type"
                onChange={event =>
                  this.setFormStatus(event.target.value)
                }
                type="select"
                value={this.state.selectedFormStatus}
              >
                <option value={''}>{this.state.selectedFormStatus ? 'Show all': 'Select status'}</option>
                <option value="draft">Draft</option>
                <option value="current">Current</option>
                <option value="revised">Revised</option>
              </Input>
            </div>
          </div>

          <div className="table-scrollable">
            <table className="table table-striped">
              <thead>
              <tr>
                <th>
                  <div className="header">
                    <span>Type </span>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Short </span>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Status </span>
                  </div>
                </th>

                <th>
                  <div className="header">
                    <span>Updated at </span>
                  </div>
                </th>
                <th>
                  <div className="header">
                    <span>Actions </span>
                  </div>
                </th>

              </tr>
              </thead>

              <tbody>
              {this.filteredForms && this.filteredForms.map((form, index) => (
                <tr key={index.toString()}>
                  <td> {form.name} </td>
                  <td> {form.type.toUpperCase()} </td>
                  <td>
                  <span className={classNames('badge', {
                    'badge-primary': form.status === 'revised',
                    'badge-secondary': form.status === 'draft',
                    'badge-success': form.status === 'current'
                  })}>
                  {form.getCapitalized('status')}
                  </span>
                  </td>
                  <td> {moment(form.updatedAt).format('MMM D, YYYY')} </td>
                  <td>
                    <div className="td-actions">
                      <ReactTooltip place="top" className='customTheme' effect="solid"/>
                      <button
                        className="button small default"
                        data-tip={this.canEditOrActivate(form) ? 'Edit' : 'Show details'}
                        onClick={() => this.onViewForm(form.guid)}>
                        {
                          this.canEditOrActivate(form)
                            ? (
                              <Fragment>
                                <i className="fa fa-edit"/>
                              </Fragment>
                            )
                            : (
                              <Fragment>
                                <i className="fa fa-list"/>
                              </Fragment>
                            )
                        }
                      </button>

                      {this.getCanRevise(form) &&
                      <button
                        className="button small default"
                        data-tip="Revise form"
                        onClick={() => this.onReviseForm(form.guid)}>
                        <i className="fa fa-repeat"/>
                      </button>
                      }
                      {this.canEditOrActivate(form) &&
                      <button
                        data-tip="Activate"
                        className="button small default"
                        onClick={() => this.onActivateForm(form.guid)}
                      >
                        <i className="fa fa-play-circle-o"/>
                      </button>
                      }
                    </div>
                  </td>
                </tr>

              ))}
              </tbody>
            </table>
          </div>

          <Modal
            isOpen={this.state.isCreatingForm}
            title="Create form"
            onClose={() => this.closeCreateForm()}
          >
            {this.state.isCreatingForm
              ? <CustomForm
                config={createFormConfig}
                onSubmit={(form) => this.onSubmit(form)}
                isLoading={this.state.isCreateFormLoading}
              />
              : null
            }
          </Modal>

        </div>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    forms: state.forms.list,
    isLoading: !!state.forms.isLoading.length,
    userContext: state.common.userContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    activateForm: (formGuid) => {
      return dispatch(formsActionCreators.activateForm(formGuid));
    },
    reviseForm: (formGuid) => {
      return dispatch(formsActionCreators.reviseForm(formGuid));
    },
    createForm: (form) => {
      return dispatch(formsActionCreators.createForm(form));
    },
    createFormType: (form_type) => {
      return dispatch(commonActions.createFormType(form_type));
    },
    setSelectedForm: (formGuid) => {
      return dispatch(formsActionCreators.setSelectedForm(formGuid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FormIndex);

